import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, FormHelperText, InputAdornment
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { Pricepercentgrp } from '../TitleList';
import styled, { inputNumbers, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createPricePerEntry } from '../../Store/PHPSlice/Sale/PricePercent';
import PricePercentTable from '../SaleTables/PricePercentTbl/PricePerTable';
import { errorStyles } from '../../Utils/table';


const PricePercentGEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        grpNm: '',
        actct: '100',
        hu: '',
        mrp: '',
        calHu: '',
        calMrp: '',
        userId: userdata?.ID
    });
    const [number, setNumber] = useState('');
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleAcutalCostChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            actct: value
        })
    };
    const handleHuOnChange = (event) => {
        const value = event.target.value;
        const calculatedValue = (parseInt(formData.actct, 10) * value) / 100;
        if (calculatedValue > 0) {
            const finalvalue = calculatedValue + parseInt(formData.actct, 10);

            setFormData({
                ...formData,
                hu: value,
                calHu: finalvalue
            });
        } else {
            setFormData({
                ...formData,
                calHu: ''
            });
        }
    };

    const handleMrpChange = (event) => {
        const value = event.target.value;
        const mr = (parseFloat(value) * parseFloat(1)) / 100;
        const mr1 = parseFloat(formData.calHu) / (1 - mr);
        var ans = round5(mr1);

        setFormData((prevFormData) => ({
            ...prevFormData,
            mrp: value,
            calMrp: ans
        }));
    };


    function round5(x) {
        var y = (x % 5) >= 2.5 ? parseInt(x / 5) * 5 + 5 : parseInt(x / 5) * 5;
        return y;
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.grpNm) newErrors.grpNm = 'Group Name is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        dispatch(createPricePerEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Price Percentage Group Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={Pricepercentgrp} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Price Percentage Group</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Group Name', name: 'grpNm' },


                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                                {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <TableContainer style={{
                                        width: isDesktop ? '100%' : '100%',
                                        marginLeft: isDesktop ? '25%' : '0%',
                                        overflowX: 'hidden'
                                    }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Actual Cost</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Firm ON</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>MRP</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >
                                                        <TextField
                                                            type="text"
                                                            value={formData.actct}
                                                            onChange={handleAcutalCostChange}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >
                                                        <TextField
                                                            type="text"
                                                            value={formData.hu}
                                                            onChange={handleHuOnChange}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                            }}
                                                        />

                                                    </TableCell>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >
                                                        <TextField
                                                            type="text"
                                                            value={formData.mrp}
                                                            onChange={handleMrpChange}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">MU</InputAdornment>,
                                                            }}
                                                        />

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >

                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >
                                                        <TextField
                                                            type="text"
                                                            value={formData.calHu}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} >
                                                        <TextField
                                                            type="text"
                                                            value={formData.calMrp}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                        />
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
                <PricePercentTable />
            </div>
        </>
    );
}

export default PricePercentGEntry;
